import { authHeader } from './auth-header';

export const userService = {
    login,
    logout,
    register,
    getAll,
};

function login(username, password) {
    
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            action: "login",
            username: username,
            password: password
        })
    };
    return fetch(`https://vuedev.aic.pet/api.php`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // login successful if there's a jwt token in the response
            if (user.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user));
            }
            return user;
        });
}




function logout() {
    let openid = "";
    try {
        openid = (JSON.parse(localStorage.getItem("user") || "{}") || {}).openid || "";
    } catch (e) {
        openid = "";
    }
    localStorage.removeItem('user');
    if (!openid) return;
    const origin = (process.env.VUE_APP_SOCIAL_API || "https://so-api.aicocloud.com").replace(/\/$/, "");
    fetch(`${origin}/oauth/revoke`, {
        method: "POST",
        headers: { Openid: openid },
    }).catch(() => {});
}

function register(user) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };
    return fetch(`/users/register`, requestOptions).then(handleResponse);
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`/users`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload(true);
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}
